import React from 'react'
import "./VerticalRotateText.css"
const VerticalRotateText = () => {
    return (
        <div className="Iam">
            <b>
                <div className="innerIam">
                    Hi All<br />
                    I am Syed Javith <br />
                    This My Profile<br />
                    built on React<br />
                </div>
            </b>

        </div>
    )
}

export default VerticalRotateText
